/* ========== ADMIN TWO‑PANEL LAYOUT ========== */
.chat-admin-layout {
  display: flex;
  height: 75vh;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.06);
  overflow: hidden;
}

/* ---------- Left Sidebar ---------- */
.chat-sidebar {
  width: 300px;
  min-width: 300px;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  background: #f9fafb;
  transition: all 0.3s ease;
}

.sidebar-header {
  padding: 24px 20px 16px;
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sidebar-search {
  padding: 0 16px 12px;
}

.sidebar-search input {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  font-size: 13px;
  background: #fff;
  outline: none;
  box-sizing: border-box;
}

.sidebar-search input:focus {
  border-color: #667eea;
}

.user-list-vertical {
  flex: 1;
  overflow-y: auto;
  padding: 4px 12px;
}

.user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 4px;
}

.user-item:hover {
  background: #eef2ff;
}

.user-item.active {
  background: #e0e7ff;
  box-shadow: inset 3px 0 0 #667eea;
}

.user-avatar-small {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 15px;
  flex-shrink: 0;
}

.user-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.user-info .user-name {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-info .user-role {
  font-size: 11px;
  color: #64748b;
  text-transform: capitalize;
}

.conversation-preview {
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

.user-item.active .conversation-preview {
  color: #4338ca;
}

/* ---------- Right Chat Panel ---------- */
.chat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.no-chat-selected {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 16px;
}

/* ========== CHAT CONTAINER ========== */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.chat-header {
  padding: 20px 28px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.chat-header-title {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-header-spacer {
  width: 60px;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #f9fafb;
}

.message {
  max-width: 75%;
  padding: 12px 18px;
  border-radius: 20px;
  word-break: break-word;
  line-height: 1.5;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.message.sent {
  background: #667eea;
  color: #fff;
  align-self: flex-end;
  border-bottom-right-radius: 4px;
}

.message.received {
  background: #fff;
  border: 1px solid #e2e8f0;
  align-self: flex-start;
  border-bottom-left-radius: 4px;
}

.message .time {
  font-size: 10px;
  opacity: 0.7;
  margin-top: 6px;
  display: block;
}

.typing-indicator {
  font-style: italic;
  color: #6b7280;
  padding: 8px 20px;
  font-size: 13px;
}

.chat-input {
  display: flex;
  padding: 20px 24px;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  gap: 12px;
  align-items: center;
}

.chat-input input[type="text"] {
  flex: 1;
  padding: 14px 18px;
  border: 2px solid #e1e5e9;
  border-radius: 30px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
  min-width: 0;
}

.chat-input input:focus {
  border-color: #667eea;
}

.chat-input button {
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  border: none;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s;
  white-space: nowrap;
  flex-shrink: 0;
}

.chat-input button:hover {
  opacity: 0.9;
}

/* ========== BACK BUTTON ========== */
.back-btn {
  display: none;
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.2s;
}

.back-btn:hover {
  background: rgba(255,255,255,0.15);
}

.back-arrow {
  font-size: 20px;
}

/* ========== RESPONSIVE - Mobile (WhatsApp style) ========== */
@media (max-width: 900px) {
  .chat-admin-layout {
    height: 100vh;
    border-radius: 0;
    position: relative;
  }

  .chat-sidebar {
    width: 100%;
    min-width: 100%;
    border-right: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 1;
    transition: transform 0.3s ease;
  }

  .chat-sidebar.mobile-hidden {
    transform: translateX(-100%);
  }

  .chat-main {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 2;
    background: #fff;
    transition: transform 0.3s ease;
  }

  .chat-main.mobile-hidden {
    transform: translateX(100%);
  }

  .back-btn {
    display: flex;
  }

  .chat-header {
    padding: 14px 16px;
    font-size: 16px;
  }

  .chat-header-spacer {
    width: 40px;
  }

  .chat-header-title {
    font-size: 16px;
  }

  .chat-messages {
    padding: 16px;
  }

  .message {
    max-width: 85%;
    padding: 10px 14px;
    font-size: 14px;
  }

  .chat-input {
    padding: 12px 16px;
    gap: 8px;
  }

  .chat-input input[type="text"] {
    padding: 12px 16px;
    font-size: 14px;
  }

  .chat-input button {
    padding: 10px 16px;
    font-size: 13px;
  }

  .btn-submit {
    flex: 0 0 auto;
    width: auto;
    min-width: 60px;
    padding: 10px 16px;
  }

  .chat-header-actions {
    padding: 6px 16px;
  }

  .no-chat-selected {
    display: flex;
  }

  .user-list-vertical {
    padding: 4px 8px;
  }

  .user-item {
    padding: 14px 12px;
  }

  .sidebar-header {
    padding: 16px 16px 12px;
  }

  .sidebar-search {
    padding: 0 12px 12px;
  }

  .msg-search-bar {
    padding: 8px 12px;
    gap: 6px;
  }

  .msg-search-bar input {
    padding: 8px 12px;
    font-size: 13px;
  }

  .pinned-messages {
    padding: 8px 12px;
  }

  .pinned-msg {
    min-width: 130px;
    max-width: 160px;
    padding: 6px 10px;
  }
}

/* Smaller phones */
@media (max-width: 400px) {
  .chat-header {
    padding: 12px 12px;
    font-size: 15px;
  }

  .chat-header-spacer {
    width: 30px;
  }

  .chat-messages {
    padding: 12px;
  }

  .message {
    max-width: 90%;
    padding: 8px 12px;
    font-size: 13px;
  }

  .chat-input {
    padding: 10px 12px;
    gap: 6px;
  }

  .chat-input input[type="text"] {
    padding: 10px 14px;
    font-size: 13px;
  }

  .chat-input button {
    padding: 8px 14px;
    font-size: 12px;
  }

  .user-item {
    padding: 12px 10px;
  }

  .user-avatar-small {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .back-text {
    display: none;
  }

  .back-btn {
    padding: 6px 8px;
  }
}

/* ========== DESKTOP - Keep original design ========== */
@media (min-width: 901px) {
  .chat-sidebar.mobile-hidden,
  .chat-main.mobile-hidden {
    display: flex !important;
  }

  .chat-sidebar,
  .chat-main {
    position: relative;
    transform: none !important;
  }

  .chat-sidebar {
    width: 300px;
    min-width: 300px;
  }

  .back-btn {
    display: none !important;
  }

  .no-chat-selected {
    display: flex;
  }
}

/* ========== SHARED STYLES ========== */
.btn-attach {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 10px 14px;
  transition: background 0.2s, transform 0.1s;
  color: #475569;
  flex-shrink: 0;
}

.btn-attach:hover:not(:disabled) {
  background: #e2e8f0;
  transform: scale(1.05);
}

.btn-attach:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.uploading-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-size: 13px;
  white-space: nowrap;
  flex-shrink: 0;
}

.uploading-text::before {
  content: "";
  width: 12px;
  height: 12px;
  border: 2px solid #667eea;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.chat-file-link {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 8px;
  color: inherit;
  text-decoration: none;
  margin-top: 4px;
  font-size: 0.9rem;
}

.chat-file-link:hover {
  background: rgba(255, 255, 255, 0.35);
}

.file-preview-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  padding: 8px 20px;
  font-size: 13px;
}

.btn-submit {
  flex: 0 0 auto;
  width: auto;
  min-width: 70px;
  padding: 12px 20px;
  font-size: 14px;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-unread-badge {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 7px;
  border-radius: 999px;
  margin-left: auto;
  min-width: 22px;
  text-align: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25);
}

.sub-members {
  padding-left: 20px;
}

.sub-member {
  padding-left: 30px;
}

.expand-btn {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  font-size: 12px;
  padding: 0 4px;
  flex-shrink: 0;
}

.message .sender {
  display: block;
  font-weight: 700;
  font-size: 0.8rem;
  margin-bottom: 4px;
  letter-spacing: 0.3px;
  opacity: 0.9;
}

.message.received .sender {
  color: #2d3748;
}

.message.sent .sender {
  color: rgba(255, 255, 255, 0.85);
}

.message p {
  margin-top: 0;
}

/* ---------- PINNED MESSAGES ---------- */
.pinned-messages {
  background: linear-gradient(135deg, #fef9c3 0%, #fef3c7 100%);
  border-bottom: 2px solid #fbbf24;
  padding: 10px 20px;
}

.pinned-header {
  font-weight: 700;
  font-size: 11px;
  color: #92400e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.pinned-scroll {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.pinned-msg {
  display: flex;
  flex-direction: column;
  background: rgba(255,255,255,0.7);
  border-radius: 10px;
  padding: 8px 12px;
  min-width: 160px;
  max-width: 200px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  border: 1px solid rgba(251,191,36,0.3);
}

.pinned-msg:hover {
  background: rgba(255,255,255,0.95);
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
}

.pinned-msg-sender {
  font-weight: 700;
  font-size: 11px;
  color: #92400e;
  margin-bottom: 2px;
}

.pinned-msg-text {
  font-size: 12px;
  color: #4b5563;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- PIN BUTTON ---------- */
.msg-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
}

.pin-btn {
  background: none;
  border: none;
  font-size: 11px;
  cursor: pointer;
  opacity: 0;
  padding: 2px 4px;
  border-radius: 4px;
  transition: all 0.2s;
  color: #999;
}

.message:hover .pin-btn {
  opacity: 0.4;
}

.pin-btn:hover {
  opacity: 1 !important;
  background: rgba(0,0,0,0.06);
}

.pin-btn.active {
  opacity: 1;
  color: #f59e0b;
}

.message.pinned {
  border-left: 3px solid #f59e0b;
  padding-left: 15px;
}

/* ---------- MESSAGE SEARCH BAR ---------- */
.chat-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.search-toggle-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
}

.search-toggle-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.msg-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.msg-search-bar input {
  flex: 1;
  padding: 8px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 20px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;
  min-width: 0;
}

.msg-search-bar input:focus {
  border-color: #667eea;
}

.search-count {
  font-size: 12px;
  font-weight: 600;
  color: #667eea;
  background: #eef2ff;
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

.search-nav-btn {
  width: 28px;
  height: 28px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  font-size: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  transition: all 0.2s;
  flex-shrink: 0;
}

.search-nav-btn:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.search-close-btn {
  width: 28px;
  height: 28px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc2626;
  transition: all 0.2s;
  flex-shrink: 0;
}

.search-close-btn:hover {
  background: #fee2e2;
}

.msg-highlight {
  background: #fef3c7 !important;
  border-radius: 8px;
  transition: background 0.5s;
}

.loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #e5e7eb;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 20px auto;
}

.error-message {
  background: #fee2e2;
  color: #991b1b;
  padding: 8px 16px;
  font-size: 13px;
  text-align: center;
}

/* ========== CHAT INPUT - Compact like WhatsApp/Telegram ========== */
.chat-input {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  gap: 8px;
}

.chat-input input[type="text"] {
  flex: 1;
  padding: 10px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 24px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  min-width: 0;
  background: #f8fafc;
}

.chat-input input[type="text"]:focus {
  border-color: #667eea;
  background: #fff;
}

/* Attach button - circular icon */
.btn-attach {
  width: 40px;
  height: 40px;
  min-width: 40px;
  background: none;
  border: none;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: all 0.2s;
  flex-shrink: 0;
}

.btn-attach:hover:not(:disabled) {
  background: #f1f5f9;
  color: #667eea;
}

.btn-attach:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Send button - compact circle like chat apps */
.btn-send {
  width: 40px;
  height: 40px;
  min-width: 40px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  padding: 0;
  font-size: 12px;
}

.btn-send:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

.btn-send:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: #cbd5e1;
}

/* Uploading text */
.uploading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  color: #64748b;
  font-size: 12px;
  flex-shrink: 0;
}

.uploading-text::after {
  content: "";
  width: 14px;
  height: 14px;
  border: 2px solid #667eea;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

/* Remove old btn-submit styles only for chat UI buttons */
.chat-container .btn-submit,
.chat-page .btn-submit,
.chat-layout .btn-submit {
  display: none;
}

/* Chat header search button */
.chat-header-search {
  background: rgba(255,255,255,0.15) !important;
  border: none !important;
  color: #fff !important;
  width: 36px;
  height: 36px;
  border-radius: 50% !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}

.chat-header-search:hover {
  background: rgba(255,255,255,0.25) !important;
}

/* Remove old chat-header-actions */
.chat-header-actions {
  display: none;
}

/* Search bar styling */
.msg-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.msg-search-bar input {
  flex: 1;
  padding: 8px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 20px;
  font-size: 13px;
  outline: none;
  min-width: 0;
}

.msg-search-bar input:focus {
  border-color: #667eea;
}

.search-count {
  font-size: 11px;
  font-weight: 600;
  color: #667eea;
  background: #eef2ff;
  padding: 4px 8px;
  border-radius: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

.search-nav-btn,
.search-close-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  flex-shrink: 0;
  background: #f8fafc;
  color: #475569;
}

.search-nav-btn:hover { background: #e2e8f0; }
.search-close-btn { background: #fef2f2; color: #dc2626; border-color: #fecaca; }
.search-close-btn:hover { background: #fee2e2; }

/* No chat selected */
.no-chat-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

/* Responsive adjustments */
@media (max-width: 900px) {
  .chat-input {
    padding: 8px 12px;
    gap: 6px;
  }
  .chat-input input[type="text"] {
    padding: 10px 14px;
    font-size: 13px;
  }
  .btn-attach,
  .btn-send {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }
  .chat-header-search {
    width: 32px;
    height: 32px;
  }
}